import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IDataPoolState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const datapoolModule: Module<IDataPoolState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default datapoolModule
